import { Platform } from "react-native";
import { css } from "styled-components/native";

export const matchPairConatinerWidth = (theme: any) => {
  if (!theme.isMobile) {
    if (Platform.OS === "web") {
      return css`
        width: 452px;
      `;
    } else
      return css`
        width: 380px;
      `;
  } else {
    return css`
      max-width: 100%;
    `;
  }
};
